import { getProduct } from '#/products/domain';

interface SupportedPriceView {
  readonly isSupported: true;
  readonly value?: string | null;
  readonly isValid: boolean;
  readonly precision: number;
}

interface UnsupportedPriceView {
  readonly isSupported: false;
  readonly isValid: true;
  readonly value?: string;
}

export type PriceView = SupportedPriceView | UnsupportedPriceView;

/**
 * @template {object} PriceView - Response Type definition
 *    @property {boolean} isSupported - wheater leg pricing input is supported or not
 *    @property {boolean} isValid - wheater leg price value is a valid price
 *    @property {string?} value - value of leg price
 *    @property {number} precision - number of decimal places derived from the product's min tick size (only on supported view)
 * @param {string} price {string | undefined | null} price of leg
 * @param {boolean} isHedge if leg is hedge
 * @param {string} productCode product code used to look up price precision
 * @returns {PriceView} PriceView
 */
export function priceView(
  price: string | undefined | null,
  isHedge: boolean,
  productCode: string,
): PriceView {
  if (!isHedge) return createUnsupportedPriceView();

  const { pricePrecision } = getProduct(productCode);
  return createSupportedPriceView(price, pricePrecision);
}

function createSupportedPriceView(
  price: string | undefined | null,
  precision: number,
): SupportedPriceView {
  if (price == null)
    return { isSupported: true, value: price, isValid: false, precision };
  const isValid = Number.isFinite(Number.parseFloat(price));
  return { isSupported: true, value: price, isValid, precision };
}

function createUnsupportedPriceView(): UnsupportedPriceView {
  return { isSupported: false, isValid: true };
}
